import "../../../css/DesignSystem/Upload/UploadedFileList.css";
import { ReactComponent as RemoveIcon } from "../../../assets/icons/Close- new.svg";
const UploadedFileList = ({
  files = [],
  onRemove,
  removable = true,
  canRemove,
}) => {
  return (
    <div className="ds-uploaded-list">
      {files.map((file, index) => (
        <div key={file.id || file.name} className="ds-uploaded-chip py-xs px-s">
          {file.url ? (
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="FP_Content ds-uploaded-name"
              style={{
                textDecoration: "none",
                color: "inherit",
                cursor: "pointer",
              }}
            >
              {file.name}
            </a>
          ) : (
            <span className="FP_Content ds-uploaded-name primary">{file.name}</span>
          )}
          {removable && (canRemove ? canRemove(file, index) : true) && (
            <button
              type="button"
              className="ds-uploaded-remove"
              onClick={() => onRemove?.(file, index)}
              aria-label={`Remove ${file.name}`}
            >
              <RemoveIcon />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default UploadedFileList;
